import { render, staticRenderFns } from "./CreateNewEmailTemplate.vue?vue&type=template&id=b261db9e"
import script from "./CreateNewEmailTemplate.vue?vue&type=script&lang=js"
export * from "./CreateNewEmailTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports